import api from "@/shared/utils/api";

export interface Role {
  id: string;
  role_name: string;
  uid: number;
  is_active: boolean;
}

export class RoleService {
  /**
   * Get all active roles
   * @returns Promise with all active roles
   */
  static async getAll(): Promise<Role[]> {
    try {
      const response = await api.get("/api/roles");
      return response.data;
    } catch (error) {
      console.error("Failed to fetch roles:", error);
      throw error;
    }
  }
}
